import {
  EmailFormat,
  ProductSelectionType,
  Section,
  SharedProps,
} from "@redotech/redo-model/email-builder";
import { ok } from "@redotech/util/fp/coerced-result";
import { memo } from "react";
import { StaticRecommendedProduct } from "../../../product-recommendations";
import { InlineEmailButton } from "../button";
import { AmpEmailInteractiveCart } from "./amp-cart";
import { StaticEmailInteractiveCart } from "./static-cart";
export type InteractiveCartProps = Section.InteractiveCart & SharedProps;

export const EmailInteractiveCart = memo(function EmailInteractiveCart(
  props: InteractiveCartProps & {
    staticRecommendedProducts: StaticRecommendedProduct[];
  },
) {
  if (
    props.format === EmailFormat.AMP &&
    props.productSelectionType !== ProductSelectionType.STATIC
  ) {
    return <AmpEmailInteractiveCart {...props} format={props.format} />;
  }
  return <StaticEmailInteractiveCart {...props} format={EmailFormat.STATIC} />;
});

export const LineItemButton = (
  props: Section.Button & SharedProps & { noPadding?: boolean },
) => {
  const withUpsellParameterResult = ok(props.buttonLink).map((urlStr) => {
    const url = new URL(urlStr ?? "");
    url.searchParams.set("u", "1");
    return url;
  });
  const buttonLink = withUpsellParameterResult.ok
    ? props.utm.applyToUrl(withUpsellParameterResult.value).toString()
    : undefined;

  return (
    <InlineEmailButton
      {...{
        ...props,
        as: props.as || "button",
        sectionColor: "inherit",

        // Marking this button with the u=1 query param will allow us to identify an upsell click in snowflake analytics queries.
        // It shows up in the Order collection at {"trackingAnalytics.email.eventType": "Click"}
        buttonLink,
      }}
      autoWidth
      noPadding={props.noPadding}
    />
  );
};
